export default __webpack_public_path__ + "static/TaberCertified-cd5511192bac321fa928bfa1730bc83f.jpg";